import { map, distinctUntilChanged, startWith } from 'rxjs/operators';

import { ContentObserver } from '@angular/cdk/observers';
import { Directive, ElementRef, Output, Input, inject } from '@angular/core';

import { shareRef } from '@shared/operators/share-ref.operator';

@Directive({
  selector: '[textOverflow]',
  standalone: false,
})
export class TextOverflow {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private co = inject(ContentObserver);

  // to pass on without subscribing
  @Input('textOverflow')
  textOverflowInput: any;

  @Output()
  readonly textOverflow = this.co.observe(this.el).pipe(
    startWith(0),
    map(() => this.el.nativeElement.scrollWidth - this.el.nativeElement.clientWidth > 0),
    distinctUntilChanged(),
    shareRef(),
  );
}
